export default __webpack_public_path__ + "79dd328c04ec9bf282590c6e2c3ff3d6.svg";